import { BCMSDate, BCMSRecord, useBCMSContext, useParams, Workflow } from "@bcm-dev/bcms-vite";
import Classes, { Account, ACHBatch, CompanyAccount, Participant } from "model";
import React from "react";

import OneTimeACHPaymentPage from "components/pages/OneTimeACHPaymentPage";
// Steps of the workflow
const steps = [ OneTimeACHPaymentPage ];

/**
 * @function OneTimeACHWorkflow
 * @returns {React.Component}
 * @exported true
 * @description The main workflow component for the quick transfer workflow
 * @example
 * <OneTimeACHWorkflow />
 */
export default function OneTimeACHWorkflow(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { stepID } = useParams();
    const { state } = context ?? {};
    const { branding } = state ?? {};
    const { options } = branding ?? {};

  
    const value = getDefaultData();
    const hasImmediateOption = options.onetimeach_immediate_abi22 === "true";
    const hasOneTimeSameDay = options.onetimeach_same_day_abi22 === "true";
    value.data.oneTimeACHPayment.scheduleType = hasImmediateOption ?  "immediate" : hasOneTimeSameDay ? "same day" : "future dated";
    value.data.oneTimeACHPayment.effectiveDate = hasImmediateOption ? BCMSDate.init().nextBusinessDay() : hasOneTimeSameDay ? BCMSDate.init() : BCMSDate.init().nextBusinessDay();

    return <Workflow value={ value } steps={ steps } step={ stepID }  />
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @exported true
 * @description Hook to return the steps of the workflow
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultData
 * @returns {OBJECT}
 * @exported true
 * @description Hook to return the default state of the workflow
 */
export const getDefaultData = () => {
    return {
        data: {
            oneTimeACHPayment: ACHBatch.init({ 
                id: ACHBatch.nextID(), 
                name: "One-Time",
                scheduleType: "immediate", 
                pendingApprovals: "1",
                effectiveDate: BCMSDate.init().nextBusinessDay(),
                status:"pending approval",
                creditAmount: "0", 
                debitAmount: "0"
            }),
            companyAccounts: CompanyAccount.initAll(),
            offsetAccounts: Account.initAllBusinessAsset(),
            achFromAccounts: {
                accounts: [] // always empty by default since we are making a new payment.
            }, 
            achToParticipants: {
                participants: [] // always empty by default since we are making a new payment.
            }, 
            participants: Participant.initAll().map(item => {
                // "isSelected" will be used to keep track of row selection.
                item.isSelected = undefined;
                return item;
            }),
            allParticipants: Participant.initAll().map(item => {
                // "isSelected" will be used to keep track of row selection.
                item.isSelected = undefined;
                return item;
            }),
            groupSearchValue: "",
            selectedOffsetAccount: { account: undefined }
        },
        ui: {
            achParticipantsModalIsOpen: { isActive: false },
            transactionTypeSelectIsActive: { isActive: false },
            secCodeSelectIsActive: { isActive: false },
            companySelectIsActive: { isActive: false },
            effectiveDateSelectIsActive: { isActive: false },
            offsetAccountSelectIsActive: { isActive: false },
            showOneTimeACHModal: { isActive: true },
            showSecCode: { isActive: false },
            scheduleSelectIsActive: { isActive: false },
        }
    }
};